module.exports = __webpack_public_path__ + "static/media/arrow-left-ayuda.170f1e6d.svg";